import React, { PureComponent } from "react";
import _ from "lodash";
import {
  Card,
  CardBody,
  Col,
  Button,
  ButtonToolbar,
  Container,
  Row,
  Table,
  Modal,
} from "reactstrap";
import {
  MDBDataTable,
  MDBBtn,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
} from "mdbreact";
import axios from "axios";
import Select from "react-select";
/*import './App.css';*/
import { Multiselect } from "multiselect-react-dropdown";
import { Dropdown } from "semantic-ui-react";
import { Field, reduxForm } from "redux-form";
import EyeIcon from "mdi-react/EyeIcon";
import EmailIcon from "mdi-react/EmailIcon";
import AccountSearchIcon from "mdi-react/AccountSearchIcon";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import renderFileInputField from "../../../../shared/components/form/FileInput";
import renderSelectField from "../../../../shared/components/form/Select";
import renderMultiSelectField from "../../../../shared/components/form/MultiSelect";
import Util from '../../../Common/util';
import API from '../../../Common/api';
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';

const options = [];
var url = window.location.hostname;
var port = window.location.port;

/*console.log(url);
 if (window.location.hostname = "localhost") {
  url = "15.206.34.41"+":8088";
 }else{
    url = window.location.hostname+":8088";
 }*/

class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.toggle = this.toggle.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.fetchGRNData = this.fetchGRNData.bind(this);
    this.result = this.result.bind(this);
    this.btnClick = this.btnClick.bind(this);
    this.togglePressCancel = this.togglePressCancel.bind(this);
    this.messagetoggle = this.messagetoggle.bind(this);
    this.cancelMessageModal = this.cancelMessageModal.bind(this);
    
    this.accessCookie = this.accessCookie.bind(this);
    this.multiSelectEl = [];

    this.state = {
      showPassword: false,
      selectedPicksheetType: "",
      schemas: [],
      showFetchGRNData: false,
      confirmbtn: false,
      showFetchGRNData1: false,
      pickSheetTypeVal: "",
      showPrintLoader: false,
      Confirmmodal: false,
      TypeValue: "",
      loading: false,
      grnNumber: "",
      grnValues: "",
      grnLineValue: "",
      selectedOptions: "",
      fileNameVal: "",
      batch_id: "",
      changeStatus: "",
      alertMessage: "",
      messageModal: false,
      postsGRN: [],
      postsProduct: [],
      tableRowsGRN: [],
      ErrorRowData: [],
      options: [],
      newArrayData: [],
      selectedUser: {},
      selectedUser1:{},
      showAssignButton: true,
      showPrintButton: false,
      loadingprintbtn: false,
      value: "0",
      modal_picktype: "",
    };
  }

  result(params) {
    console.log(params);
  }

  messagetoggle() {
    this.setState({
      messageModal: true,
    });
  }

  cancelMessageModal() {
    this.setState({
      messageModal: false,
    });
  }

   Confirmtoggle() {
    this.setState((prevState) => ({ Confirmmodal: !prevState.Confirmmodal }));
  }



handlePrint =()=>{
    if(this.state.TypeValue == "NPP"){
      this.Confirmtoggle();
    }else{
     this.processData(); 
    }
  }

handleFile1(){
   

      this.setState({
        showPrintLoader: true
      })
      
     console.log("sdfghjdfg");

     const payload = {
              id: this.state.fileNameVal,
              print: "ptl" ,
              location: this.state.selectedLocation,
              batch_id: this.state.batch_id
          };

        API.post('/picking/printSheet/v1/', { param: payload })
     
      .then((response) =>  {

        if (response.data[0].pickType == "TESTER") {

         console.log(JSON.stringify(response.data));
       
        var new_data = {};

        for(var i=0;i < response.data.length;i++){
             var tmp = response.data[i];
             if(new_data[tmp.userName] == undefined){
                 new_data[tmp.userName] = [response.data[i]];
             }else{
                  new_data[tmp.userName].push(response.data[i]);
             }
        
}

        console.log(new_data);


        localStorage.setItem('pickType' , "Tester");
        localStorage.setItem('printData' , JSON.stringify(new_data));
        console.log(localStorage.getItem('printData'));



        }else{

        const printData = {}
        /*alert(response.data.success_response[0].message);
        this.fetchGRNData();*/
        var new_data = {};

        for(var i=0;i < response.data.length;i++){
      if(response.data[i].pickType === "BREAKPACK"){
      if(!printData[response.data[i].userName]){
        printData[response.data[i].userName] = {}
      }
      if(!printData[response.data[i].userName][response.data[i].basepackCode+response.data[i].sequence]){
        printData[response.data[i].userName][response.data[i].basepackCode+response.data[i].sequence] = []
      }
      printData[response.data[i].userName][response.data[i].basepackCode+response.data[i].sequence].push(response.data[i])
      }else{
      if(!printData[response.data[i].userName]){
        printData[response.data[i].userName] = {}
      }
      if(!printData[response.data[i].userName][response.data[i].basepackCode]){
        printData[response.data[i].userName][response.data[i].basepackCode] = []
      }
      printData[response.data[i].userName][response.data[i].basepackCode].push(response.data[i])
      }
          
             // var tmp = response.data[i];
             // if(new_data[tmp.userName] == undefined){
             //     new_data[tmp.userName] = [response.data[i]];
             // }else{
             //      new_data[tmp.userName].push(response.data[i]);
             // }
        
        }
        console.log("PRINT - ",printData);
    
        const sortedData = {}
        try{
          for(let userName in printData){
            if(!sortedData[userName]){
              sortedData[userName] = []
            }
            for(let basepackCode in printData[userName]){
              sortedData[userName].push(printData[userName][basepackCode])
            }
            sortedData[userName].sort((a, b) => {
              if(a.length == 1 && b.length == 1){
                // return a[0].zoneName > b[0].zoneName || a[0].binAddress < b[0].binAddress
                if (a[0].storageType == b[0].storageType ) {
                  if(a[0].zoneName == b[0].zoneName){
                    if(a[0].binAddress > b[0].binAddress){
                      return 1
                    }else if(a[0].binAddress < b[0].binAddress){
                      return -1
                    }else{
                      return 0
                    }
                  }else{
                    if(a[0].zoneName > b[0].zoneName){
                      return 1
                    }else if(a[0].zoneName < b[0].zoneName){
                      return -1
                    }else{
                      return 0
                    }
                  }
                }else{
                  if(a[0].storageType > b[0].storageType){
                    return 1
                  }else if(a[0].storageType < b[0].storageType){
                    return -1
                  }else{
                    return 0
                  }
                }
              }else{
                if(a.length > 1){
                  a.sort((subA, subB) => {
                    if(subA.storageType == subB.storageType){
                      if(subA.zoneName == subB.zoneName){
                        if(subA.basepackCode == subB.basepackCode){
                          if(subA.lbSkuId == subB.lbSkuId){
                            if(subA.pkd > subB.pkd){
                              return 1
                            }else if(subA.pkd < subB.pkd){
                              return -1
                            }else{
                              return 0
                            }
                          }else{
                            if(subA.lbSkuId > subB.lbSkuId){
                              return 1
                            }else if(subA.lbSkuId < subB.lbSkuId){
                              return -1
                            }else{
                              return 0
                            }
                          }
                        }else{
                           if(subA.basepackCode > subB.basepackCode){
                            return 1
                          }else if(subA.basepackCode < subB.basepackCode){
                            return -1
                          }else{
                            return 0
                          }                       
                        }
                      }else{
                        if(subA.zoneName > subB.zoneName){
                          return 1
                        }else if(subA.zoneName < subB.zoneName){
                          return -1
                        }else{
                          return 0
                        }
                      }
                    }else{
                      if(subA.storageType > subB.storageType){
                        return 1
                      }else if(subA.storageType < subB.storageType){
                        return -1
                      }else{
                        return 0
                      }
                    }
                  })
                }
                if(b.length > 1){
                  b.sort((subA, subB) => {
                    if(subA.zoneName == subB.zoneName){
                      if(subA.zoneName == subB.zoneName){
                        if(subA.basepackCode == subB.basepackCode){
                          if(subA.lbSkuId == subB.lbSkuId){
                            if(subA.pkd > subB.pkd){
                              return 1
                            }else if(subA.pkd < subB.pkd){
                              return -1
                            }else{
                              return 0
                            }
                          }else{
                            if(subA.lbSkuId > subB.lbSkuId){
                              return 1
                            }else if(subA.lbSkuId < subB.lbSkuId){
                              return -1
                            }else{
                              return 0
                            }
                          }

                        }else{
                           if(subA.basepackCode > subB.basepackCode){
                            return 1
                          }else if(subA.basepackCode < subB.basepackCode){
                            return -1
                          }else{
                            return 0
                          }                       
                        }
                      }else{
                        if(subA.zoneName > subB.zoneName){
                          return 1
                        }else if(subA.zoneName < subB.zoneName){
                          return -1
                        }else{
                          return 0
                        }
                      }
                    }else{
                      if(subA.storageType > subB.storageType){
                        return 1
                      }else if(subA.storageType < subB.storageType){
                        return -1
                      }else{
                        return 0
                      }
                    }
                  })
                }
                return a.length - b.length
              }
            })
          }
        }catch(error){
          console.log(error)
        }

        console.log(sortedData);
        // console.log(printData);
        localStorage.setItem('pickType' , "ICLD_LOOSE");
        localStorage.setItem('printData' , JSON.stringify(sortedData))

        /*window.location.href="/print_data";*/
       /* if (window.location.href="/putaway/printPutaway") {
          window.location.reload();
        }*/

      }

      if (response.data[0].invFlag == "0" || response.data[0].invFlag == "1") {

         console.log(JSON.stringify(response.data));
       
        var new_data = {};

        for(var i=0;i < response.data.length;i++){
             var tmp = response.data[i];
             if(new_data[tmp.userName] == undefined){
                 new_data[tmp.userName] = [response.data[i]];
             }else{
                  new_data[tmp.userName].push(response.data[i]);
             }
        
}

        

         const userData = new_data;

          const groupByZoneName = (arr) => {
            const grouped = {};
            
            arr.forEach(item => {
              const zoneName = item.zoneName;
              if (!grouped[zoneName]) {
                grouped[zoneName] = [];
              }
              grouped[zoneName].push(item);
            });
            
            return grouped;
          }

          const groupedData = {};
          for(let userName in userData) {
            groupedData[userName] = groupByZoneName(userData[userName]);
          }

          console.log("groupedData", groupedData);


          const newData = { ...groupedData };

          // Iterate over each user
          for (const user in newData) {
            if (newData.hasOwnProperty(user)) {
              // Iterate over each zone for the user
              for (const zone in newData[user]) {
                if (newData[user].hasOwnProperty(zone)) {
                  // Sort the array of items in the zone based on the "sequence" key
                  newData[user][zone].sort((a, b) => a.sequence - b.sequence);
                }
              }
            }
          }

          console.log("newData==========>>>>>>>>", newData);

          

          




        localStorage.setItem('pickType' , response.data[0].toStation);
        localStorage.setItem('printData' , JSON.stringify(newData));
        localStorage.setItem("page_break_check", true);
        console.log(localStorage.getItem('printData'));



        }



        this.setState({
          loadingprintbtn: false,
          modal: false,
          showAssignButton: false,
          showPrintButton: true,
          showPrintLoader: false
        })

        if(this.state.selectedPicksheetType == "NPP"){
          window.open('/printPickigNPPHulDetail','_blank');
        }else{

        if(response.data[0].invFlag == "1"){
            window.open('/printPickigHulDetail','_blank');
        }else{
          window.open('/printPickigHulDetail','_blank');
        }
      }
        
         
      })
      .catch(function (error) {
        
        
        
    });

  }



radioChangeGroup =(type)=>{
    this.setState({
      pickSheetType: type
    })

  }


  processData = () => {
    
    this.setState({
      loadingprintbtn: true,
      showPrintLoader: true,
      confirmbtn: true
    });

    const { selectedUser, selectedUser1,newArrayData } = this.state;

    let payloadArray = [];
    let printData = [];
    const uniqueZoneData = {};
    let selectedUserLength = {};

    var ITEM_PICKTYPE = "";
    newArrayData.map((item) => {
      ITEM_PICKTYPE = item.pickType;
      if (
        item.pickType.toLowerCase() == "carton" ||
        item.pickType.toLowerCase() == "outer" ||
        item.pickType.toLowerCase() == "breakpack"
      ) {
        //if (item.lbSkuId.startsWith("C-LB") == false) {
        if (item.pickType.toLowerCase() === "breakpack") {
          var lbksu_pkd = item.OrderId;
        } else {
          var lbksu_pkd = item.OrderId + "_" + item.zoneId;
        }

        if (!uniqueZoneData[lbksu_pkd]) {
          uniqueZoneData[lbksu_pkd] = [];
        }
        uniqueZoneData[lbksu_pkd].push(item);
        //}
      } else {
        if (!uniqueZoneData[item.zoneId]) {
          uniqueZoneData[item.zoneId] = [];
        }
        uniqueZoneData[item.zoneId].push(item);
      }
    });

    _.map(uniqueZoneData, (item, key) => {
      if (this.state.selectedUser1[key] != undefined) {
        if (ITEM_PICKTYPE.toLowerCase() === "breakpack") {
          var item_per_user = 1;
        } else {
          var item_per_user = parseInt(
            item.length / this.state.selectedUser1[key].length
          );
        }

        let inc = 0;
        let userIndex = 0;
        item.map((putawayHistoryItem, index) => {
          if (ITEM_PICKTYPE.toLowerCase() == "breakpack") {
            var userId = selectedUser1[key]["value"];
          } else {
            var userId = selectedUser1[key][userIndex]["value"];
          }
          var cartonPutaway = false;
          newArrayData.map((cartonputawayHistory, carton_index) => {
            if (
              cartonputawayHistory.pickRequestId ==
                putawayHistoryItem.pickRequestId &&
              cartonputawayHistory.ocldFlag.toString() == "1"
            ) {
              payloadArray.push({
                pickingHistoryId: cartonputawayHistory.pickingHistoryId,
                userId: userId,
              });
              printData.push({
                userId: userId,
                data: cartonputawayHistory,
              });
              cartonPutaway = true;
            }
          });
          payloadArray.push({
            pickingHistoryId: putawayHistoryItem.pickingHistoryId,
            userId: userId,
          });
          printData.push({
            userId: userId,
            data: putawayHistoryItem,
          });

          inc++;
          if (inc % item_per_user == 0) {
            userIndex++;
          }

          if (ITEM_PICKTYPE.toLowerCase() === "breakpack") {
            userIndex = 0;
          } else {
            if (!selectedUser1[key][userIndex]) {
              userIndex = 0;
            }
          }
        });
      }
    });

    /*for(let i = newArrayData.length; i > 0; i--){
      let userId = (selectedUserLength[newArrayData[i-1].zoneId] - 1) < 0 ? selectedUser[newArrayData[i-1].zoneId][0] : selectedUser[newArrayData[i-1].zoneId][selectedUserLength[newArrayData[i-1].zoneId] - 1]
      payloadArray.push({
        putawayHistoryId: newArrayData[i-1].putawayHistoryId,
        userId: userId
      })
      printData.push({
        userId: userId,
        data: newArrayData[i-1]
      })
      selectedUserLength[newArrayData[i-1].zoneId] -= 1
    }*/
    let uniq_pickingHisId = [];
    let unique_payloadArray = [];
    payloadArray.map((payload_set, index) => {
      if (
        uniq_pickingHisId.indexOf(payload_set["pickingHistoryId"].toString()) <=
        -1
      ) {
        uniq_pickingHisId.push(payload_set["pickingHistoryId"].toString());
        unique_payloadArray.push(payload_set);
      } else {
        let index = unique_payloadArray.findIndex(
          (x) =>
            x.pickingHistoryId.toString() ===
            payload_set["pickingHistoryId"].toString()
        );
        unique_payloadArray[index]["userId"] = payload_set["userId"];
      }
    });
    // console.log("Total Data - ", newArrayData);
    // console.log("Assign - ", payloadArray);
    // console.log("PickingHis - ", uniq_pickingHisId);
    // console.log("Assign 2 - ", unique_payloadArray);
    // console.log("uniqueZoneData - ", uniqueZoneData);

    if (newArrayData.length !== unique_payloadArray.length) {
      this.setState(
        {
          loadingprintbtn: false,
          showPrintLoader: false,
        },
        () => {
          alert("Assign all Zone to users");
        }
      );

      return false;
    }
    console.log("PayloadArray ===>>>>", unique_payloadArray);

    // return false;

    /*localStorage.setItem('printData' , JSON.stringify(printData));*/
    /*window.location.href="/print_data";*/
    const payload = {
      arr_data: unique_payloadArray,
      location: this.state.selectedLocation,
  };

  addAnalytics('Picking Assign', 'Picksheet Assign & Print', payload);

API.post('/picking/updatePickingPrintStatus/v1/', { param: payload })
      .then((response) => {
        console.log("resp",response)
        if(response.data.status == true){
          this.handleFile1();
        }else{
          const reason = response.data.reason;
          const skuCodes = response.data.products.map(product => product.sku7_code).join(', ');

          // Result
          const result = `${reason}, and the products are: ${skuCodes}.`;
          console.log(result);
          this.messagetoggle();

          this.setState({
            alertMessage: result,
            showPrintLoader: false

          })
          return false
        }


        return false;
        console.log(response.data["success_response"][0].pickType + "if");

        if (response.data["success_response"][0].pickType == "TESTER") {
          console.log(JSON.stringify(response.data));

          var new_data = {};

          for (var i = 0; i < response.data["success_response"].length; i++) {
            var tmp = response.data["success_response"][i];
            if (new_data[tmp.userName] == undefined) {
              new_data[tmp.userName] = [response.data["success_response"][i]];
            } else {
              new_data[tmp.userName].push(response.data["success_response"][i]);
            }
          }

          localStorage.setItem("pickType", "Tester");
          localStorage.setItem("printData", JSON.stringify(new_data));

          this.setState({
            loadingprintbtn: false,
            modal: false,
            showAssignButton: false,
            showPrintButton: true,
            showPrintLoader: false,
          });
          //this.fetchGRNData();
          //window.open("/printPickigData", "_blank");
        } else {
          const printData = {};
          /*alert(response.data.success_response[0].message);
          this.fetchGRNData();*/
          var new_data = {};

          for (var i = 0; i < response.data["success_response"].length; i++) {
            if (response.data["success_response"][i].pickType === "BREAKPACK") {
              if (!printData[response.data["success_response"][i].userName]) {
                printData[response.data["success_response"][i].userName] = {};
              }
              if (
                !printData[response.data["success_response"][i].userName][
                  response.data["success_response"][i].basepackCode +
                    response.data["success_response"][i].sequence
                ]
              ) {
                printData[response.data["success_response"][i].userName][
                  response.data["success_response"][i].basepackCode +
                    response.data["success_response"][i].sequence
                ] = [];
              }
              printData[response.data["success_response"][i].userName][
                response.data["success_response"][i].basepackCode +
                  response.data["success_response"][i].sequence
              ].push(response.data["success_response"][i]);
            } else {
              if (!printData[response.data["success_response"][i].userName]) {
                printData[response.data["success_response"][i].userName] = {};
              }
              if (
                !printData[response.data["success_response"][i].userName][
                  response.data["success_response"][i].basepackCode
                ]
              ) {
                printData[response.data["success_response"][i].userName][
                  response.data["success_response"][i].basepackCode
                ] = [];
              }
              printData[response.data["success_response"][i].userName][
                response.data["success_response"][i].basepackCode
              ].push(response.data["success_response"][i]);
            }

            // var tmp = response.data[i];
            // if(new_data[tmp.userName] == undefined){
            //     new_data[tmp.userName] = [response.data[i]];
            // }else{
            //      new_data[tmp.userName].push(response.data[i]);
            // }
          }

          const sortedData = {};
          try {
            for (let userName in printData) {
              if (!sortedData[userName]) {
                sortedData[userName] = [];
              }
              for (let basepackCode in printData[userName]) {
                sortedData[userName].push(printData[userName][basepackCode]);
              }
              sortedData[userName].sort((a, b) => {
                if (a.length == 1 && b.length == 1) {
                  // return a[0].zoneName > b[0].zoneName || a[0].binAddress < b[0].binAddress
                  if (a[0].storageType == b[0].storageType) {
                    if (a[0].zoneName == b[0].zoneName) {
                      if (a[0].binAddress > b[0].binAddress) {
                        return 1;
                      } else if (a[0].binAddress < b[0].binAddress) {
                        return -1;
                      } else {
                        return 0;
                      }
                    } else {
                      if (a[0].zoneName > b[0].zoneName) {
                        return 1;
                      } else if (a[0].zoneName < b[0].zoneName) {
                        return -1;
                      } else {
                        return 0;
                      }
                    }
                  } else {
                    if (a[0].storageType > b[0].storageType) {
                      return 1;
                    } else if (a[0].storageType < b[0].storageType) {
                      return -1;
                    } else {
                      return 0;
                    }
                  }
                } else {
                  if (a.length > 1) {
                    a.sort((subA, subB) => {
                      if (subA.storageType == subB.storageType) {
                        if (subA.zoneName == subB.zoneName) {
                          if (subA.basepackCode == subB.basepackCode) {
                            if (subA.lbSkuId == subB.lbSkuId) {
                              if (subA.pkd > subB.pkd) {
                                return 1;
                              } else if (subA.pkd < subB.pkd) {
                                return -1;
                              } else {
                                return 0;
                              }
                            } else {
                              if (subA.lbSkuId > subB.lbSkuId) {
                                return 1;
                              } else if (subA.lbSkuId < subB.lbSkuId) {
                                return -1;
                              } else {
                                return 0;
                              }
                            }
                          } else {
                            if (subA.basepackCode > subB.basepackCode) {
                              return 1;
                            } else if (subA.basepackCode < subB.basepackCode) {
                              return -1;
                            } else {
                              return 0;
                            }
                          }
                        } else {
                          if (subA.zoneName > subB.zoneName) {
                            return 1;
                          } else if (subA.zoneName < subB.zoneName) {
                            return -1;
                          } else {
                            return 0;
                          }
                        }
                      } else {
                        if (subA.storageType > subB.storageType) {
                          return 1;
                        } else if (subA.storageType < subB.storageType) {
                          return -1;
                        } else {
                          return 0;
                        }
                      }
                    });
                  }
                  if (b.length > 1) {
                    b.sort((subA, subB) => {
                      if (subA.zoneName == subB.zoneName) {
                        if (subA.zoneName == subB.zoneName) {
                          if (subA.basepackCode == subB.basepackCode) {
                            if (subA.lbSkuId == subB.lbSkuId) {
                              if (subA.pkd > subB.pkd) {
                                return 1;
                              } else if (subA.pkd < subB.pkd) {
                                return -1;
                              } else {
                                return 0;
                              }
                            } else {
                              if (subA.lbSkuId > subB.lbSkuId) {
                                return 1;
                              } else if (subA.lbSkuId < subB.lbSkuId) {
                                return -1;
                              } else {
                                return 0;
                              }
                            }
                          } else {
                            if (subA.basepackCode > subB.basepackCode) {
                              return 1;
                            } else if (subA.basepackCode < subB.basepackCode) {
                              return -1;
                            } else {
                              return 0;
                            }
                          }
                        } else {
                          if (subA.zoneName > subB.zoneName) {
                            return 1;
                          } else if (subA.zoneName < subB.zoneName) {
                            return -1;
                          } else {
                            return 0;
                          }
                        }
                      } else {
                        if (subA.storageType > subB.storageType) {
                          return 1;
                        } else if (subA.storageType < subB.storageType) {
                          return -1;
                        } else {
                          return 0;
                        }
                      }
                    });
                  }
                  return a.length - b.length;
                }
              });
            }
          } catch (error) {
            console.log(error);
          }

          localStorage.setItem("pickType", "ICLD_LOOSE");
          // console.log(printData);
          localStorage.setItem("printData", JSON.stringify(sortedData));

          /*window.location.href="/print_data";*/
          /* if (window.location.href="/putaway/printPutaway") {
          window.location.reload();
        }*/


        if (response.data["success_response"][0].invFlag == "0" || response.data["success_response"][0].invFlag == "1") {
          console.log(JSON.stringify(response.data));

          var new_data = {};

          for (var i = 0; i < response.data["success_response"].length; i++) {
            var tmp = response.data["success_response"][i];
            if (new_data[tmp.userName] == undefined) {
              new_data[tmp.userName] = [response.data["success_response"][i]];
            } else {
              new_data[tmp.userName].push(response.data["success_response"][i]);
            }
          }

          localStorage.setItem("pickType", "Tester");
          localStorage.setItem("printData", JSON.stringify(new_data));

          
          //this.fetchGRNData();
          //window.open("/printPickigData", "_blank");
        }

          this.setState({
            loadingprintbtn: false,
            modal: false,
            showAssignButton: false,
            showPrintButton: true,
            showPrintLoader: false,
            confirmbtn: false,
            Confirmmodal: false
          });

           if(this.state.TypeValue == "NPP"){
          if(this.state.pickSheetTypeVal == "combined"){
            window.open("/printPickigNPPHulAllDetail", "_blank");
          }else{
            window.open("/printPickigNPPHulDetail", "_blank");
          }
          
        }else{

        if(response.data["success_response"][0].invFlag == "1"){
            window.open('/printPickigHulData','_blank');
        }else{
          window.open('/printPickigHulData','_blank');
        }
      }



          this.fetchGRNData();

         
          //window.open("/printPickigData", "_blank");
        }

        /* console.log(JSON.stringify(response.data));
       
        var new_data = {};

        for(var i=0;i < response.data["success_response"].length;i++){
             var tmp = response.data["success_response"][i];
             if(new_data[tmp.userName] == undefined){
                 new_data[tmp.userName] = [response.data["success_response"][i]];
             }else{
                  new_data[tmp.userName].push(response.data["success_response"][i]);
             }
        
}

        console.log(new_data);
        localStorage.setItem('printData' , JSON.stringify(new_data));
        console.log(localStorage.getItem('printData'));
*/
      })
      .catch(function(error) {});
  };

  togglePressCancel() {
    this.setState({
      modal: false,
      selectedOptions: "",
      selectedUser: {},
      selectedUser1:{},
    });
  }

  submitclick = () => {
    this.fetchGRNData();
  };

  handleChange(event) {
     let index = event.nativeEvent.target.selectedIndex;
    let label = event.nativeEvent.target[index].text;
    console.log('label', label);
    const myArray = label.split("-");

    console.log('myArray', myArray[0])
  

    localStorage.setItem('selected_option', myArray[0]);
    this.setState({
      value: event.target.data,
      fileNameVal: label,
      batch_id: event.target.value,
      selectedPicksheetType: myArray[0],

      showAssignButton: true,
      showPrintButton: false,
    });




    //localStorage.setItem("fileNameVal", event.target.value);

    //this.fetchGRNData();
  }

  onChangeVal = (options, id) => {
    const { selectedUser,selectedUser1 } = this.state;

    //if(Object.keys(selectedUser).indexOf(id.toString()) > -1){
    // for(let i=0;i < options.length;i++){
    //this.state.selectedUser[id].push(options[i]);
    //}
    //}else{
    selectedUser[id] = options;
    selectedUser1[id]=options;
    //}

    this.setState({
      selectedUser,
      selectedUser1,
    });
  };

  btnClick(putAwayId, Status) {
    /* options=[];*/

    if (Status === "UNHOLD") {
      this.setState({
        changeStatus: "hold",
      });
    } else {
      this.setState({
        changeStatus: "unhold",
      });
    }

    var arr = [];
    var orderData = {};
    orderData["putawayHistoryId"] = putAwayId;

    if (Status === "UNHOLD") {
      orderData["changeStatus"] = "hold";
    } else {
      orderData["changeStatus"] = "unhold";
    }

    arr.push(orderData);

    const payload = {
      arr_data: arr,
      location: this.state.selectedLocation,
      create: true,
  };

API.post('/picking/updateHoldStatus/v1/', { param: payload })
      .then((response) => {
        /*alert(response.data.success_response[0].message);*/
        this.setState({
          alertMessage: response.data.success_response[0].message,
          messageModal: true,
        });

        this.fetchGRNData();
      })
      .catch(function(error) {});
  }

  fetchGRNData() {
    var fileNameValue = localStorage.getItem("fileNameVal");
    var ref = this;
    this.setState({
      showFetchGRNData: true,
      tableRowsGRN: [],
      loading: true,
    });

    const payload = {
      fileName: this.state.fileNameVal,
      batch_id: this.state.batch_id,
      pickType: 1,
      location: this.state.selectedLocation,
  };
   addAnalytics('Picking Assign', 'Assign Picksheet Filter', payload);

   API.post('/picking/fetchPicksheetInfo/v1/', { param: payload })

      .then((response) => response.data)

      .then((data) => {
        console.log("PICKING______",data);

        // if (err) throw err;

        this.setState({ postsGRN: data });
        if(data.length > 0){
          this.setState({
            TypeValue: data[0].sheetType
          })
        }
      })

      .then(async () => {
        ref.setState({
          tableRowsGRN: ref.assemblePostsGRN(),
          isLoading: false,
          loading: false,
        });
      });
  }

  assemblePostsGRN = () => {
    console.log("this.state.postsGRN", this.state.postsGRN);
    let items = this.state.postsGRN.sort(function(a, b) {
      if (a.bucket !== undefined) {
        var textA = parseInt(a.sequence);
        var textB = parseInt(b.sequence);
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      } else {
        return 1;
      }
    });

    console.log("ITEMS_______", items);

    var arrayData = items.filter(
      (item) => item.parentmerge == false
    );

    let postsGRN = arrayData.map((post, index) => {
      //if (post.parentmerge == false) {
        return {
          serial: index + 1,

          /*grnNumber: post.grnNumber,

          gnrLineNumber: post.gnrLineNumber,*/

          /*putawayHistoryId: post.putawayHistoryId,*/
          /*status: post.status == 'UNHOLD' ? <MDBBtn onClick={r => this.btnClick(post.putawayHistoryId, post.status)} style={{backgroundColor: '#4ce1b6' , color: '#fff'}} color="default" rounded size="sm">Hold</MDBBtn> : <MDBBtn  style={{backgroundColor: '#de5361', color: '#fff'}} onClick={r => this.btnClick(post.putawayHistoryId, post.status)} rounded size="sm">Release</MDBBtn>,*/

          /*binId: post.binAddress,

          zone_name: post.zoneName,

          zone_id: post.zoneId,

          lbskuid: post.lbSkuId,

          pickType: post.pickType,*/
          bin_id: post.binAddress,
          prod_identifier: post.productIdentifier,
          
          upc: post.upc,

          mrp: post.mrp,
          pkd : post.pkd,
          product_desc: post.productName,
          free_loose: post.freeProduct == 1 ? post.totalLooseQty : "",
          free_cld: post.freeProduct == 1 ? post.totalIcldQty : "",
           loose_to_be_picked: post.pickedLooseQty,
           picked_loose: post.freeProduct == 0 ? post.totalLooseQty : "",
           cld_to_be_picked: post.pickedIcldQty,
           picked_cld: post.freeProduct == 0 ? post.totalIcldQty : "",


          /*cbuCode: post.cbuCode,

          toPickIcldQty: post.toPickIcldQty,

          toPickLooseQty: post.toPickLooseQty,

          toPickTesterQty: post.toPickTesterQty,*/

          // PickIcldQty: post.pickedIcldQty,

          // PickLooseQty: post.pickedLooseQty,

          // PickTesterQty: post.pickedTesterQty,

          //pkd: post.pkd,
        };
      //}
    });

    return postsGRN;
  };

  fetchUserList() {
    const payload = {
      location: this.state.selectedLocation,
  };

API.post('/auth/users/getusers', { param: payload })
      .then((response) => {
        for (var i = 0; i < response.data.length; i++) {
          // <---- Move declaration inside loop

          var orderData = {};
          orderData["label"] = response.data[i].userName;
          orderData["value"] = response.data[i].userId;

          options.push(orderData);
        }

        /* console.log(this.state.options);*/
      })
      .catch(function(error) {});
  }

  componentWillMount() {
    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090";
    } else if (
      window.location.port == 8098 ||
      window.location.port === ":8098"
    ) {
      port = ":8099";
    } else {
      port = ":8088";
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8088";
    } else {
      url = window.location.hostname + port;
    }

    var cookieUsername = this.getCookie("token");
    var Location = this.getCookie("selectedLocation");
    var username = this.accessCookie("token");
    this.setState({
      userName: cookieUsername,
      selectedLocation: Location,
    });

    localStorage.setItem("userName", username);
  }

  

  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(";");
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  componentDidMount() {
    const payload = {
      location: this.state.selectedLocation,
      picksheetType: 1,
  };

API.post('/picking/fetchPicksheetList/v1/', { param: payload })
      .then((response) => {
        this.setState({
          schemas: response.data,
        });
      })
      .catch(function(error) {});

    this.fetchUserList();
  }

  toggle() {
    this.setState({ selectedUser: {}, modal: true, newArrayData: [] });

    /*var newArray = this.state.postsGRN.filter(status='UNHOLD');*/
    var arrayCartData = this.state.postsGRN;
    this.setState({
      newArrayData: arrayCartData,
    });
    const { selectedUser1 } = this.state;
    for (let i = 0; i < arrayCartData.length; i++){
      var id = arrayCartData[i].zoneId;
      selectedUser1[id] = [options[0]];
    };
    this.setState({   
      selectedUser1,
    });
  }

  showPassword = (e) => {
    e.preventDefault();
    this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
  };

  render() {
    const { handleSubmit, reset, t } = this.props;
    const { showPassword, newArrayData, selectedUser, Confirmmodal } = this.state;
    const { modal } = this.state;
    const { messageModal } = this.state;
    var uniqueZoneData = {};
    const CartonuniqueZoneData = {};
    const OuteruniqueZoneData = {};
    const CLBuniqueZoneData = {};
    var lbksu_pkd = "";

    const sale_pickreq = {};
    newArrayData.map((item) => {
      this.setState({
        modal_picktype: item.pickType,
      });

      if (
        item.pickType.toLowerCase() == "carton" ||
        item.pickType.toLowerCase() == "outer" ||
        item.pickType.toLowerCase() == "breakpack"
      ) {
        console.log("ODLD -", item.ocldFlag.toString());
        if (
          item.ocldFlag.toString() == "0" ||
          item.ocldFlag.toString() == "1"
        ) {
          if (item.pickType.toLowerCase() == "breakpack") {
            var lbksu_pkd = item.OrderId;
          } else {
            var lbksu_pkd = item.OrderId + "_" + item.zoneId;
          }

          if (!uniqueZoneData[lbksu_pkd]) {
            uniqueZoneData[lbksu_pkd] = {
              zoneId: item.zoneId,
              OrderId: item.OrderId,
              zoneName: item.zoneName,
              pickType: item.pickType.toLowerCase(),
              pickRequestId: lbksu_pkd,
              items: [],
            };
          }

          if (Object.keys(OuteruniqueZoneData).indexOf(lbksu_pkd) == -1) {
            OuteruniqueZoneData[lbksu_pkd] = 1;
            sale_pickreq[lbksu_pkd] = [item.pickRequestId.toString()];
          } else {
            OuteruniqueZoneData[lbksu_pkd] += 1;
            sale_pickreq[lbksu_pkd].push(item.pickRequestId.toString());
          }

          uniqueZoneData[lbksu_pkd].items.push(item);
        } else {
          var lbksu_pkd =
            item.OrderId + "_" + item.zoneId + "_" + item.pickRequestId;
          if (!CartonuniqueZoneData[lbksu_pkd]) {
            CartonuniqueZoneData[lbksu_pkd] = {
              zoneId: item.zoneId,
              OrderId: item.OrderId,
              zoneName: item.zoneName,
              pickType: item.pickType.toLowerCase(),
              pickRequestId: lbksu_pkd,
              items: [],
            };
            CartonuniqueZoneData[lbksu_pkd].items.push(item);
          }
          if (Object.keys(CLBuniqueZoneData).indexOf(lbksu_pkd) == -1) {
            CLBuniqueZoneData[lbksu_pkd] = 1;
          } else {
            CLBuniqueZoneData[lbksu_pkd] += 1;
          }
        }
      } else {
        if (!uniqueZoneData[item.zoneId]) {
          uniqueZoneData[item.zoneId] = {
            zoneId: item.zoneId,
            zoneName: item.zoneName,
            pickType: item.pickType,
            items: [],
          };
        }
        uniqueZoneData[item.zoneId].items.push(item);
      }
    });

    console.log("Saleable", CLBuniqueZoneData);
    console.log("CARTON", OuteruniqueZoneData);
    console.log("Saleable_p", sale_pickreq);

    for (const property in CLBuniqueZoneData) {
      var split_property_order = property.split("_")[0];

      var order_arr = [];
      Object.keys(OuteruniqueZoneData).forEach(function(data, index) {
        if (data != undefined) {
          var order_no = property.split("_")[0];
          order_arr.push(order_no);
        }
      });

      if (order_arr.indexOf(split_property_order) > -1) {
        for (const sale_property in OuteruniqueZoneData) {
          var split_property_order = property.split("_")[0];
          var sale_split_order = sale_property.split("_")[0];

          if (
            split_property_order == sale_split_order &&
            sale_pickreq[sale_property].indexOf(
              property.split("_")[2].toString()
            ) > -1
          ) {
            OuteruniqueZoneData[sale_property] += CLBuniqueZoneData[property];
            CLBuniqueZoneData[property] = 0;
          }
        }
      } else {
        uniqueZoneData = CartonuniqueZoneData;
        OuteruniqueZoneData[property] = CLBuniqueZoneData[property];
      }
    }

    const GRNData = {
      columns: [
        {
          label: "S No.",

          field: "serial",
          minimal: "sm",
        },

        {
          label: "BIN Id",

          field: "bin_id",
          minimal: "sm",
        },

        {
          label: "Prod. Identifier",

          field: "prod_identifier",
          minimal: "lg",
        },   

        {
          label: "UPC",

          field: "upc",
          minimal: "lg",
        },

        {
          label: "MRP",

          field: "mrp",
          minimal: "lg",
        },
        {
          label : "PKD",
          field : "pkd",
          minimal:"sm"      
          }, 

        {
          label: "Product Desc",

          field: "product_desc",
          minimal: "lg",
        },

        {
          label: "Free Loose",

          field: "free_loose",
          minimal: "lg",
        },

        {
          label: "Free CLD",

          field: "free_cld",
          minimal: "lg",
        },

        {
          label: "Loose to be picked",

          field: "loose_to_be_picked",
          minimal: "lg",
        },

        {
          label: "Picked Loose",

          field: "picked_loose",
          minimal: "lg",
        },

        {
          label: "CLD to be picked",

          field: "cld_to_be_picked",
          minimal: "lg",
        },

        {
          label: "Picked CLD",

          field: "picked_cld",
          minimal: "lg",
        },



        //{
          //label: "To Pick Loose Quantity (pcs)",

         // field: "toPickLooseQty",
        //  minimal: "lg",
//},

       // {
         // label: " To Pick Tester Quantity (pcs)",

         // field: "testerQuantity",
         // minimal: "lg",
       // },
        // {
        //   label: "Picked Icld Quantity (Box)",

        //   field: "PickIcldQty",
        //   minimal: "lg",
        // },

        // {
        //   label: "Picked Loose Quantity (pcs)",

        //   field: "PickLooseQty",
        //   minimal: "lg",
        // },

        // {
        //   label: "Picked Tester Quantity (pcs)",

        //   field: "PickTesterQty",
        //   minimal: "lg",
        // },

        //{
          //label: "PKD",

          //field: "pkd",
          //minimal: "lg",
        //},
      ],

      rows: this.state.tableRowsGRN,
    };
    return (
      <Col xl={12}>
        <Card>
          <CardBody style={{height: 200}}>
            <div className="card__title">
              <h5 className="bold-text"></h5>
            </div>
            <form className="form form--inline" onSubmit={handleSubmit}>
              <div
                className="form__form-group col-xl-4"
                style={{ display: "inline-flex" }}
              >
                <span
                  className="form__form-group-label col-xl-5"
                  style={{ display: "none", paddingTop: 6, paddingBottom: 6 }}
                >
                  Select Picksheet
                </span>

                <div
                  className="form__form-group-field col-xl-4"
                  style={{ display: "contents" }}
                >
                  <select
                    className="form-control grn_line_no"
                    style={{ fontSize: 13 }}
                    value={this.state.value}
                    onChange={this.handleChange}
                  >
                    <option value="0" dis>
                      Select Picksheet No.
                    </option>
                    {this.state.schemas &&
                      this.state.schemas.length > 0 &&
                      this.state.schemas.map((schema) => {
                        return (
                          <option value={schema.batch_id}>
                            {" "}
                            {schema.fileName}
                          </option>
                        );
                      })}
                  </select>
                </div>
              </div>

              {/*<div className="form__form-group col-xl-3">
                <div className="form__form-group-field"></div>
              </div>*/}

              <div className="form__form-group col-xl-2">
                <ButtonToolbar className="form__button-toolbar">
                  <button
                    color="primary"
                    className="btn-sm button_enable "
                    style={{
                      fontWeight: "normal",
                      textTransform: "capitalize",
                      borderRadius: 5,
                      backgroundColor: "#70bbfd",
                      color: "#fff",
                      padding: "5px 25px",
                      fontSize: "14px",
                      textTransform: "capitalize",
                    }}
                    id="button_enable"
                    onClick={this.submitclick}
                  >
                    {this.state.loading && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    Submit
                  </button>
                </ButtonToolbar>
              </div>
            </form>
            <div className="notes" style={{ paddingTop: "15px" }}>
              <p
                style={{
                  marginBottom: "13px",
                  fontSize: "15px",
                  paddingLeft: "16px",
                }}
              >
                <b>Note</b> : 1. Tasks can be assigned by zones to one or many
                users.
              </p>
            </div>
          </CardBody>

          {this.state.showFetchGRNData && (
            <CardBody style={{ marginTop: 20 }}>
              <div className="table_header">
                <ButtonToolbar className="form__button-toolbar">
                  {this.state.showAssignButton && (
                    <Button
                      color="primary"
                      className="btn-sm"
                      onClick={this.toggle}
                      type="submit"
                      style={{ textTransform: "capitalize" }}
                    >
                      Assign
                    </Button>
                  )}
                  {this.state.showPrintButton && (
                    <Button
                      color="primary"
                      className="btn-sm"
                      type="submit"
                      style={{ textTransform: "capitalize" }}
                    >
                      Print
                    </Button>
                  )}
                </ButtonToolbar>
              </div>

              <MDBTable scrollX={true} striped bordered>
                <MDBTableHead columns={GRNData.columns} />

                <MDBTableHead>
                  {this.state.loading && (
                    <div
                      style={{
                        width: "2300%",
                        textAlign: "center",
                        paddingTop: 22,
                      }}
                    >
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px", fontSize: 18 }}
                      />
                    </div>
                  )}
                </MDBTableHead>
                <MDBTableBody rows={GRNData.rows} />
              </MDBTable>
            </CardBody>
          )}
        </Card>

         <Modal id="sheet_type_modal_width" style={{minWidth: 697}} isOpen={Confirmmodal} toggle={this.Confirmtoggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.Confirmtoggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <h5 style={{ width: "46%" }}>Select one of them </h5>
            <div style={{ width: "76%" }}>
              <input
                onChange={() => this.radioChangeGroup("combined")}
                className="radio_align"
                style={{ marginRight: 6 }}
                type="radio"
                id="html"
                name="group"
                value="exsisting_group"
              />
              <label style={{ marginRight: 12 }} for="html">
                Combined Cld & Loose
              </label>
              <input
                onChange={() => this.radioChangeGroup("separate")}
                style={{ marginRight: 6 }}
                type="radio"
                className="radio_align"
                id="css"
                name="group"
                value="new_group"
              />
              <label for="css">Separate Cld & Loose</label>
            </div>
            
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.processData}
            >
            {this.state.confirmbtn && (
                  <i
                    className="fa fa-refresh fa-spin"
                    style={{ marginRight: "5px" }}
                  />
                )}
              Confirm
            </Button>
          </ButtonToolbar>
        </Modal>


        <Modal
          isOpen={modal}
          toggle={this.toggle}
          style={{ maxWidth: 900, padding: 0 }}
        >
          <div className="modal__header" style={{ backgroundColor: "#70bbfd" }}>
            <h4
              className="text-modal  modal__title"
              style={{ color: "#fff", paddingTop: 10 }}
            >
              Assign Users
            </h4>
          </div>
          <div className="modal__body overflow_style" style={{ padding: 14, paddingBottom: 130, }}>
            <Table
              className="table--bordered"
              style={{ paddingBottom: 50}}
            >
              <thead>
                <tr>
                  {this.state.modal_picktype.toLowerCase() == "carton" ||
                  this.state.modal_picktype.toLowerCase() == "outer" ||
                  this.state.modal_picktype.toLowerCase() == "breakpack" ? (
                    <th>Order Id</th>
                  ) : (
                    ""
                  )}
                  {this.state.modal_picktype.toLowerCase() !== "breakpack" ? (
                    <th>Zone Id</th>
                  ) : (
                    ""
                  )}
                  {this.state.modal_picktype.toLowerCase() !== "breakpack" ? (
                    <th>Zone Name</th>
                  ) : (
                    ""
                  )}
                  <th>Line Count</th>
                  <th>Users</th>
                </tr>
              </thead>
              <tbody>
                {Object.keys(uniqueZoneData).length > 0 &&
                  _.map(uniqueZoneData, (item, key) => (
                    <tr key={key}>
                      {this.state.modal_picktype.toLowerCase() == "carton" ||
                      this.state.modal_picktype.toLowerCase() == "outer" ||
                      this.state.modal_picktype.toLowerCase() == "breakpack" ? (
                        <td>{item.OrderId}</td>
                      ) : (
                        ""
                      )}

                      {this.state.modal_picktype.toLowerCase() !==
                      "breakpack" ? (
                        <td>{item.zoneId}</td>
                      ) : (
                        ""
                      )}
                      {this.state.modal_picktype.toLowerCase() !==
                      "breakpack" ? (
                        <td>{item.zoneName}</td>
                      ) : (
                        ""
                      )}
                      {this.state.modal_picktype.toLowerCase() == "carton" ||
                      this.state.modal_picktype.toLowerCase() == "outer" ||
                      this.state.modal_picktype.toLowerCase() == "breakpack" ? (
                        <td>{OuteruniqueZoneData[item.pickRequestId]}</td>
                      ) : (
                        <td>{item.items.length} </td>
                      )}
                      <td>
                       
                            {this.state.modal_picktype.toLowerCase() ==
                              "carton" ||
                            this.state.modal_picktype.toLowerCase() ==
                              "outer" ||
                            this.state.modal_picktype.toLowerCase() ==
                              "breakpack" ? (
                              <Select
                                isMulti={
                                  this.state.modal_picktype.toLowerCase() ===
                                  "breakpack"
                                    ? false
                                    : true
                                }
                                name={`multiSelect_${item.pickRequestId}`}
                                defaultValue={options[0]}
                                maxMenuHeight={150}
                                value={selectedUser[item.pickRequestId]}
                                onChange={(selectedOptions) =>
                                  this.onChangeVal(
                                    selectedOptions,
                                    item.pickRequestId
                                  )
                                }
                                options={options}
                                clearable={true}
                                closeOnSelect={true}
                                 closeOnClick={false}
                                removeSelected={true}
                                className="react-select"
                                classNamePrefix="react-select"
                              />
                            ) : (
                              <Select
                                isMulti
                                name={`multiSelect_${item.zoneId}`}
                                defaultValue={options[0]}
                                value={selectedUser[item.zoneId]}
                                onChange={(selectedOptions) =>
                                  this.onChangeVal(selectedOptions, item.zoneId)
                                }
                                options={options}
                                maxMenuHeight={150}
                                clearable={true}
                                closeOnSelect={true}
                                closeOnClick={false}
                                removeSelected={true}
                                className="react-select"
                                classNamePrefix="react-select"
                              />
                            )}
                         
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>

            
          </div>
          <div>
            <ButtonToolbar className="modal__footer">
              <button
                style={{
                
                  textTransform: "capitalize",
                }}
                className="modal_cancel"
                onClick={this.togglePressCancel}
              >
                Cancel
              </button>
              <Button
                style={{
                  backgroundColor: "#24d6a3",
                  color: "#fff",
                  marginLeft: 12,
                  textTransform: "capitalize",
                }}
                className="modal_ok"
                onClick={this.processData}
              >
                {this.state.showPrintLoader && (
                  <i
                    className="fa fa-refresh fa-spin"
                    style={{ marginRight: "5px", textTransform: "capitalize" }}
                  />
                )}
                Assign and Print
              </Button>
            </ButtonToolbar>
          </div>
        </Modal>

        <Modal isOpen={messageModal} toggle={this.messagetoggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
           <span className="lnr lnr-cross-circle modal__title-icon" style={{color: 'red'}} />

            <h4> {this.state.alertMessage} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{
                backgroundColor: "#24d6a3",
                color: "#fff",
                textTransform: "capitalize",
              }}
              className="modal_ok"
              onClick={this.cancelMessageModal}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>
      </Col>
    );
  }
}

export default reduxForm({
  form: "Upload Master", // a unique identifier for this form
})(withTranslation("common")(HorizontalForm));